import * as React from "react";
import Image from "next/image";

const DEFAULT_CDN_URL =
  "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/";
const DEFAULT_CDN_SUFFIX = "svg";

// offset between uppercase ascii and regional indicator symbols
const OFFSET = 127397;

interface EmojiProps extends React.HTMLAttributes<HTMLSpanElement> {
  cdnSuffix?: string;
  cdnUrl?: string;
  countryCode: string;
  style?: React.CSSProperties;
  svg?: false;
  alt?: string;
}

interface ImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  cdnSuffix?: string;
  cdnUrl?: string;
  countryCode: string;
  style?: React.CSSProperties;
  svg?: true;
}

export type CountryFlagProps = EmojiProps | ImgProps;

export const CountryFlag = ({
  cdnSuffix = DEFAULT_CDN_SUFFIX,
  cdnUrl = DEFAULT_CDN_URL,
  countryCode,
  style,
  svg = false,
  alt,
  ...props
}: CountryFlagProps) => {
  if (typeof countryCode !== "string") {
    return null;
  }

  if (svg) {
    const flagUrl = `${cdnUrl}${countryCode.toLowerCase()}.${cdnSuffix}`;
    const flagAlt = alt || `Flag of ${countryCode}`;

    return (
      <Image
        {...props}
        src={flagUrl}
        alt={flagAlt}
        width={16}
        height={16}
        style={{
          display: "inline-block",
          width: "1em",
          height: "1em",
          verticalAlign: "middle",
          ...style,
        }}
      />
    );
  }

  const emoji = countryCode
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + OFFSET));

  return (
    <span
      role="img"
      aria-label={alt || `Flag of ${countryCode}`}
      {...props}
      style={{
        display: "inline-block",
        fontSize: "1em",
        lineHeight: "1em",
        verticalAlign: "middle",
        ...style,
      }}
    >
      {emoji}
    </span>
  );
};

export default CountryFlag;
